import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import moment, { Moment } from 'moment'

import { NotifyEmployeesFormValues } from 'core'

import DatePicker from 'common/components/dataEntry/components/DatePicker'

import { Button, Modal } from 'common/components'
import { parseZoneFormat, submitDateToServerFormatV2 } from 'common/dateFormatters'

type UpdateNotificationDateModalProps = {
  visible: boolean
  notificationDate: string
  title: string
  onCancel: () => void
  onSubmit: (values: NotifyEmployeesFormValues) => Promise<void>
  benefitStartDate: string
  isSubmitButtonLoading: boolean
}

const UpdateNotificationDateModal = ({
  visible,
  title,
  onCancel,
  onSubmit,
  notificationDate,
  benefitStartDate,
  isSubmitButtonLoading,
}: UpdateNotificationDateModalProps) => {
  const { t: translate } = useTranslation()
  const [selectedDate, setSelectedDate] = useState<string | null>(null)

  const handleDateChange = (date: Moment) => {
    setSelectedDate(parseZoneFormat(date))
  }
  const handleModalClose = () => {
    onCancel()
    setSelectedDate(null)
  }

  const handleFormSubmit = useCallback(() => {
    onSubmit({ notificationDate: submitDateToServerFormatV2(selectedDate) }).then(() => handleModalClose())
  }, [selectedDate])

  return (
    <Modal
      onCancel={handleModalClose}
      visible={visible}
      title={title}
      footer={
        <div>
          <Button onClick={onCancel}>{translate('general.cancel')}</Button>
          <Button
            loading={isSubmitButtonLoading}
            type="primary"
            disabled={selectedDate === null}
            onClick={handleFormSubmit}
          >
            Submit
          </Button>
        </div>
      }
    >
      <div>
        <label className={'mb-8 d-block'}>{translate('admin-dashboard.home.invite-alert.notification-label')}</label>

        <DatePicker
          placeholder="Choose notification date"
          defaultValue={moment(notificationDate)}
          onChange={handleDateChange}
          allowClear={false}
          disabledDate={(d) =>
            !d || d.isBefore(moment().subtract(1, 'day')) || d.isAfter(moment(benefitStartDate).add(1, 'day'))
          }
        />
      </div>
    </Modal>
  )
}

export default UpdateNotificationDateModal
